<template>
  <div class="page-content">
    <Title>{{ activityName }}</Title>
    <div class="view-bg coupon-content">
      <div class="title" v-if="!bindCoupon">怪兽充电优惠券码兑换</div>
      <div class="title-content" v-if="bindCoupon">
        <p>兑换成功</p>
        <span
          >您可在微信/支付宝端“怪兽充电EnergyMonster”小程序-个人中心-我的券包中查看</span
        >
      </div>
      <div class="line"></div>
      <div class="coupon" v-if="!bindCoupon">
        <input
          placeholder="请粘贴或输入兑换码"
          class="ipt coupon-num"
          v-model="activityCode"
        />
        <input
          placeholder="请输入您的手机号"
          type="tel"
          class="ipt phone"
          v-model="mobile"
        />
        <div style="position: relative">
          <input
            placeholder="请输入验证码"
            class="ipt code"
            v-model="captcha"
          />
          <div
            class="get-code"
            :style="
              activityCode && mobile && !isCountdown ? 'color:#02CFC1' : ''
            "
            @click="sendCode"
          >
            {{ text }}
          </div>
        </div>
        <div class="protocol">
          点击兑换即同意
          <span @click="goPact(1)">《用户协议》</span>及
          <span @click="goPact(4)">《隐私政策》</span>
        </div>
        <div
          :class="
            activityCode && mobile && captcha
              ? 'coupon-btn coupon-btn-active'
              : 'coupon-btn'
          "
          @click="exchange"
        >
          立即兑换
        </div>
        <img
          class="logo"
          src="https://cdn.enmonster.com/em-logo.png"
          alt=""
          srcset=""
        />
      </div>

      <div class="coupon-list" v-if="bindCoupon">
        <div :key="j" v-for="(i, j) in couponList" class="item">
          <div class="left-cont">
            <p>{{ i.name }}</p>
            <span>{{ i.acceptStartDate }}-{{ i.acceptEndDate }}</span>
          </div>
          <div class="right-cont" v-if="i.type == 1">
            <span class="money">{{ i.amount }}</span>
            <span class="unit">元</span>
          </div>
          <div class="right-cont" :style="i.discountAmountTopLimitShow && i.discountAmountTopLimitShow != 0 ? 'height:auto;line-height:normal;':'line-height:normal;'" v-if="i.type == 2">
            <div class="discount-limit" style="height:100%">
              <div>
                <span class="money">{{ i.discountShow }}</span>
                <span class="unit">{{ i.unit }}</span>
              </div>
              <template v-if="i.discountAmountTopLimitShow && i.discountAmountTopLimitShow != 0">
                <div class="limit">最高抵扣{{ i.discountAmountTopLimitShow }}元</div>
              </template>
            </div>
          </div>
          <div class="right-cont" v-if="i.type == 4">
            <span class="money">{{ i.deductedTime }}</span>
            <span class="unit">{{ i.unit }}</span>
          </div>
        </div>
      </div>

      <div class="list-shadow" v-if="couponList.length > 3"></div>
    </div>
    <div class="view-bg rule-content">
      <div class="title">优惠券使用说明</div>
      <div class="line"></div>
      <div class="rule" :key="index" v-for="(item, index) in textList">
        <img src="https://cdn.enmonster.com/rule-icon.png" alt="" srcset="" />
        <span>{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getQueryString } from "@/utils/utils";

export default {
  name: "CurrencyCoupon",
  computed: {},
  data() {
    return {
      activityName: "券码兑换",
      bindCoupon: false, // 兑换券码成功
      activityCode: "",
      mobile: "",
      captcha: "",
      text: "获取验证码",
      countdownTime: 60,
      isCountdown: false,
      couponList: [],
      timer: null,
      textList: [
        "按怪兽充电设备的使用流程扫码使用，结算时自动用券，订单金额低于优惠券金额时，不折算不找零。",
        "每笔订单限使用一张优惠券且不与其他优惠同享。",
        "同一账户有多张可用优惠券时，系统优先使用最高金额者，其次使用最先到期者。",
        "不同场所计费标准可能会有所不同，具体以使用充电服务时产品页面展示为准。",
        "如发生订单退款，该订单已使用的优惠券将退回至【我的券包】，有效期仍与兑换时一致。",
        "本券兑换后不退不换，不可折现，逾期失效，敬请理解。 ",
        "有关本券的疑问，请致电怪兽充电客服热线：400 670 3303",
      ],
    };
  },
  mounted() {
    this.activityCode = getQueryString("activityCode") || "";
  },
  methods: {
    // 获取验证码
    sendCode() {
      if (this.activityCode.length < 1 || this.mobile.length < 1) return;

      if (this.isCountdown) return;

      this.isCountdown = true;

      let params = {
        mobile: this.mobile,
      };
      this.$fetch(
        {
          url: "/ehs/vms/activity/sms/send",
          method: "post",
        },
        params
      ).then((res) => {
        if (res.success) {
          this.toast("获取验证码成功");
          this.text = `重新获取${this.countdownTime}s`;
          this.timer = setInterval((_) => {
            this.countdownTime--;
            if (this.countdownTime < 1) {
              this.countdownTime = 60;
              this.isCountdown = false;
              this.text = "获取验证码";
              clearInterval(this.timer);
            } else {
              let txt = `重新获取${this.countdownTime}s`;
              this.text = txt;
            }
          }, 1000);
        } else {
          this.isCountdown = false;
          this.toast(res.errorMessage);
        }
      });
    },
    // 立即兑换
    exchange() {
      if (
        this.activityCode.length < 1 ||
        this.mobile.length < 1 ||
        this.captcha.length < 1
      )
        return;

      this.$ebLoading.show();
      let params = {
        activityCode: this.activityCode,
        mobile: this.mobile,
        captcha: this.captcha,
      };
      this.$fetch(
        {
          url: "/ehs/vms/activity/distribution",
          method: "post",
        },
        params
      ).then((res) => {
        this.$ebLoading.hide();
        if (res.success) {
          this.bindCoupon = true;
          this.couponList = res.model.obtainCouponResponseDto || [];
        } else {
          this.toast(res.errorMessage);
        }
      });
    },
    // 协议
    goPact(type) {
      this.$router.push({ path: "/pact", query: { type: type } });
    },
    toast(txt) {
      // 报错提示
      this.$toast({
        styles: {
          maskColor: "rgba(0,0,0,0)",
          background: "rgba(0,0,0,0.4)",
          messageColor: "#fff",
        },
        content: txt,
        duration: 2000,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-content {
  width: 100vw;
  min-height: 100vh;
  background-color: #f7fbff;
  background-image: url("https://cdn.enmonster.com/bg.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  .view-bg {
    width: 654px;
    // min-height: 880px;
    background: linear-gradient(
      180deg,
      rgba(249, 251, 253, 0.9) 0%,
      rgba(244, 249, 255, 0.1) 100%
    );
    box-shadow: 0px 0px 120px 0px rgba(0, 0, 0, 0.1);
    border-radius: 40px;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
    .title {
      font-size: 48px;
      font-family: HarmonyOS_Sans_SC_Black;
      color: #000000;
      line-height: 68px;
      margin-top: 36px;
      font-weight: bold;
    }
    .title-content {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      margin-top: 36px;
      width: 526px;
      p {
        font-weight: bold;
        font-size: 48px;
        font-family: HarmonyOS_Sans_SC_Black;
        color: #02cfc1;
        line-height: 68px;
      }
      span {
        font-size: 24px;
        font-family: HarmonyOS_Sans_SC_Medium;
        color: #000000;
        line-height: 34px;
        margin-top: 14px;
        text-align: center;
      }
    }
    .line {
      width: 526px;
      height: 2px;
      border-top: 2px dashed #bebebe;
      margin-top: 48px;
      margin-bottom: 48px;
    }
    .coupon {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-content: center;
      align-items: center;
      .ipt {
        width: 542px;
        height: 100px;
        background: #e8ecef;
        border-radius: 66px;
        margin-bottom: 24px;
        padding-left: 40px;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: 28px;
        &::input-placeholder {
          font-size: 28px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #c6cbd1;
          line-height: 28px;
        }
      }
      .get-code {
        position: absolute;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #607172;
        line-height: 28px;
        right: 40px;
        top: 36px;
      }
      .protocol {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1a2526;
        line-height: 24px;
        margin-top: 16px;
        margin-bottom: 36px;
        span {
          color: #29c1c2;
        }
      }
      .coupon-btn {
        width: 542px;
        height: 104px;
        background: #dadee3;
        border-radius: 66px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 104px;
        text-align: center;
        margin-bottom: 48px;
      }
      .coupon-btn-active {
        background: linear-gradient(270deg, #00ddc4 0%, #00d2d2 100%);
        box-shadow: 0px 4px 16px 0px rgba(0, 196, 196, 0.46);
        color: #000000;
      }
      .logo {
        width: 234px;
        height: 20px;
        margin-bottom: 48px;
      }
    }

    .coupon-list {
      margin-top: -20px;
      position: relative;
      overflow-x: scroll;
      max-height: 540px;
      .item {
        position: relative;
        width: 654px;
        height: 184px;
        background-image: url("https://cdn.enmonster.com/coupon-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-top: -40px;
        &:first-child {
          margin-top: -20px;
        }
        .left-cont {
          position: absolute;
          top: 46px;
          left: 76px;
          width: 350px;
          p {
            font-size: 28px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #000000;
            line-height: 30px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          span {
            display: block;
            margin-top: 16px;
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #8d9d9e;
            line-height: 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .right-cont {
          position: absolute;
          top: 22px;
          right: 40px;
          width: 178px;
          height: 120px;
          line-height: 120px;
          text-align: center;
          span {
            font-size: 24px;
            font-family: DIN-Medium, DIN;
            font-weight: 500;
            color: #02cfc1;
            &:nth-child(1) {
              font-size: 60px;
              font-family: DIN-Bold, DIN;
              font-weight: bold;
              color: #02cfc1;
              line-height: 60px;
              margin-left: 8px;
            }
            &:nth-child(2) {
              margin-left: 2px;
            }
          }
          .discount-limit {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            align-content: center;
            .limit {
              font-size: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #02CFC1;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
  .coupon-content {
    position: relative;
    min-height: 100px;
    .list-shadow {
      width: 100%;
      height: 156px;
      background: linear-gradient(
        180deg,
        rgba(244, 249, 254, 0) 0%,
        #f4f8fe 100%
      );
      border-radius: 0px 0px 48px 48px;
      position: absolute;
      left: 0;
      bottom: 0;
    }
  }
  .rule-content {
    margin-top: 28px;
    align-items: flex-start;
    padding: 0 40px 30px 40px;
    margin-bottom: 88px;
    .title {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 32px;
    }
    .line {
      width: 100%;
      margin-top: 32px;
      margin-bottom: 24px;
      border-top: 2px dotted #bebebe;
    }
    .rule {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: flex-start;
      align-content: flex-start;
      margin-bottom: 16px;
      img {
        width: 10px;
        height: 20px;
        margin-right: 28px;
        margin-top: 8px;
      }
      span {
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8d9d9e;
        line-height: 38px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
